import $ from 'jquery';

const $win = $(window);
const $doc = $(document);
const $body = $('body');

export {
  $win,
  $doc,
  $body,
};
